let tspEventTypes = [
  // tsResponder
  'TsResponder list requested',
  'TsResponder names requested',
  'TsResponder created',
  'TsResponder requested',
  'TsResponder updated',
  'TsResponder deleted',
  // tsProxy
  'TsProxy list requested',
  'TsProxy created',
  'TsProxy requested',
  'TsProxy updated',
  'TsProxy deleted'
]

export default tspEventTypes
